import axiosInstance from "@/common/axiosInstance";
import apiCall from "./apiCall";

const getListInvoiceTemplate = async (param: any) => {
    const query = `?search=${param.search}&status=${param.status}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/InvoiceTemplates/GetAllInvoiceTemplates${query}`;
    return apiCall('get', URL);
};

const getInvoiceTemplateById = async (id: string) => {
    const URL = `/InvoiceTemplates/GetInvoiceTemplateById/${id}`;
    return apiCall('get', URL);
};

const putInvoiceTemplate = async (data: any) => {
    const URL = '/InvoiceTemplates/Update';
    // return apiCall('post', URL, data);
    try {
        const response = await axiosInstance.post<any[]>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const postInvoiceTemplate = async (data: any) => {
    const URL = '/InvoiceTemplates/Create';
    return apiCall('post', URL, data);
};

const deleteInvoiceTemplate = async (data: any) => {
    const URL = '/InvoiceTemplates/Delete';
    return apiCall('post', URL, data);
};

export {
    deleteInvoiceTemplate,
    postInvoiceTemplate,
    putInvoiceTemplate,
    getInvoiceTemplateById,
    getListInvoiceTemplate
}